'use client';

/**
 * useAuth - Hook to access authentication state (v2)
 * Uses TagadaContext for auth state management
 */

import { AuthState } from '../../../react/types';
import { useTagadaContext } from '../providers/TagadaProvider';

export function useAuth(): AuthState & {
    isInitialized: boolean;
} {
    const { auth, isInitialized } = useTagadaContext();

    return {
        ...auth,
        isInitialized,
    };
}

